import React from 'react';
import { testimonials } from '../data/matikka';
export function Testimonials() {
  // Hidden until authentic PRZYRODA GOTOWA reviews are added in data/przyroda.ts
  if (testimonials.length === 0) return null;
  return <section className="w-full border-t border-slate-900/10 bg-stone-50 px-8 py-24 sm:px-14 sm:py-32" data-id="element-286" data-mp="3fym7ekpgr24c">
      <div className="mx-auto max-w-6xl" data-id="element-287" data-mp="3azt3njzzaphd">
        <h2 className="font-serif text-[2.6rem] leading-[1.02] tracking-tight text-slate-900 sm:text-6xl" data-id="element-288" data-mp="3ayqcdayqul0x">
          Co mówią <em className="text-red-700" data-id="element-289" data-mp="32061gvzfdfn9">nauczyciele</em>
        </h2>

        <div className="mt-14 grid gap-10 border-t border-slate-900/15 pt-10 sm:grid-cols-3" data-id="element-290" data-mp="321z9ofpos7xd">
          {testimonials.map(item => <figure key={item.name} className="flex h-full flex-col" data-id="element-291" data-mp="2s1q9kqskq2cp">
              <div className="text-sm text-amber-500" aria-label="5 / 5 gwiazdek" data-id="element-292" data-mp="2s3jf22rgagj4">
                <span aria-hidden="true" data-id="element-293" data-mp="v8wsk7orfgbn">★★★★★</span>
              </div>
              <blockquote className="mt-4 flex-1 font-serif text-2xl leading-snug text-slate-900" data-id="element-294" data-mp="qa3ot6z9z3oo">
                ”{item.quote}”
              </blockquote>
              <figcaption className="mt-6 text-sm" data-id="element-295" data-mp="h8ayfe0pcrr8">
                <span className="font-semibold text-slate-900" data-id="element-296" data-mp="m62nm09ypzrq">{item.name}</span>
                <span className="text-slate-900/60" data-id="element-297" data-mp="78a9nck2djfn"> — {item.location}</span>
              </figcaption>
            </figure>)}
        </div>
      </div>
    </section>;
}